export const hourMask = '00:00'
export const colorMask = '#000000'; //use with const hexaPattern and hexaRegExp
export const cpfMask = '000.000.000-00'
export const dateMask = '00/00/0000';
export const hexaRegExp = new RegExp('\[a-zA-Z0-9\]');
export const specialCharacters = [ '[' ,']' , '#' ]
export const cnpjMask = '00.000.000/0000-00'
export const minus = '000000'
export const numberMask = '000000'